import request from '../request/http'

//分页查询题库
export function PageSubject(data) {
    return request({
        url: '/sp/question/pageList' ,
        method: 'post',
        data: data
    })
}
//新增题目
export function AddSubject(data) {
    return request({
        url: '/sp/question/addQuestion' ,
        method: 'post',
        data: data
    })
}
//删除题目
export function DeleteSubject(data) {
    return request({
        url: '/sp/question/delQuestion' ,
        method: 'post',
        data: data
    })
}
//修改题目
export function EditSubject(data) {
    return request({
        url: '/sp/question/updateQuestion' ,
        method: 'post',
        data: data
    })
}
//根据题目id 获取题目详情
export function QueryDetail(data) {
    return request({
        url: '/sp/question/getQuestionInfoById' ,
        method: 'post',
        data: data
    })
}
//下载模板
export function Download(data){
    return request({
        url: '/sp/question/downloadImportTemplate' ,
        method: 'post',
        data: data,
        responseType: 'arraybuffer'
    })
}
//题目导入
export function SubImport(data,questionBankId){
    return request({
        url: '/sp/question/importQuestion?questionBankId='+questionBankId,
        method: 'post',
        data: data
    })
}
//题目识别
export function Distinguish(data,questionBankId){
    return request({
        url: '/sp/question/questionRecognition?questionBankId='+questionBankId,
        headers: {
            'Content-Type': 'application/octet-stream'
        },
        method: 'post',
        data: data
    })
}
//批量导入题目
export function AllSub(data){
    return request({
        url: '/sp/question/batchAddQuestion' ,
        method: 'post',
        data: data
    })
}
/**查询题目分类数量 */
export function GetQuestionClassifyCount(data){
    return request({
        url: '/sp/question/getQuestionClassifyCount',
        method: 'post',
        data
    })
}
/**题目共享 */
export function ShareQuestion(data){
    return request({
        url: '/sp/question/shareQuestion',
        method: 'post',
        data
    })
}
/**取消题目共享 */
export function CancelShareQuestion(data){
    return request({
        url: '/sp/question/cancelShareQuestion',
        method: 'post',
        data
    })
}
/**获取题目数据 */
export function GetQuestionData(data){
    return request({
        url: '/sp/question/getQuestionData',
        method: 'post',
        data
    })
}
/**提交题目答案 */
export function SubmitQuestion(data){
    return request({
        url: '/sp/question/submitQuestion',
        method: 'post',
        data
    })
}
/**获取答题详情 */
export function GetUserQuestion(data){
    return request({
        url: '/sp/question/getUserQuestion',
        method: 'post',
        data
    })
}
/**题目迁移 */
export function MigrateQuestion(data){
    return request({
        url: '/sp/questionBank/migrateQuestion',
        method: 'post',
        data
    })
}